import {
  Datagrid,
  ReferenceField,
  TextField,
  ShowButton,
  EditButton,
  useTranslate,
  FunctionField,
} from "react-admin";
import {
  DateField,
  DeleteButton,
  CreateOnlyTopToolbar,
  CustomList,
} from "../../shared/components/index.js";

const listPromotion = () => {
  const t = useTranslate();

  return (
    <CustomList actions={<CreateOnlyTopToolbar />}>
      <Datagrid rowClick={false} bulkActionButtons={false}>
        <TextField source="title" />
        <ReferenceField source="file_id" reference="File" link="show">
          <TextField source="name" />
        </ReferenceField>
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.Promotion.source.status.${record.status}`)
          }
        />
        <DateField source="start_date" />
        <DateField source="end_date" />
        <DateField source="created_at" />
        <DateField source="updated_at" />
        <ShowButton className="button-show" />
        <EditButton className="button-edit" />
        <DeleteButton mutationMode="pessimistic" className="button-delete" />
      </Datagrid>
    </CustomList>
  );
};

export default listPromotion;
